/* eslint-disable no-irregular-whitespace */

import { orgChartClientRequiredToken, safeboxClient } from 'myNet'
import { isGlobal } from 'conf'
import store from 'store'

import orgChartDB from 'libs/DB/orgChartDB'

function ListenerObj() {
  const self = this

  self.listeners = []

  self.notify = (data) => {
    self.listeners.forEach((listener) => {
      listener(data)
    })
  }

  self.add = (listener) => {
    if (self.listeners.indexOf(listener) < 0) {
      self.listeners.push(listener)
    }
  }

  self.remove = (listener) => {
    const pos = self.listeners.indexOf(listener)
    if (pos >= 0) {
      self.listeners.splice(pos, 1)
    }
  }
}

function OrgChartHelper() {
  const self = this

  self.isLoaded = false

  self.changeListener = new ListenerObj()

  self.startLoading = async () => {
    let ret = null
    if (self.isLoaded === false) {
      self.isLoaded = await orgChartDB.getDB()
    }
    if (self.isLoaded === true) {
      try {
        const eTagInfo = await orgChartDB.getData('info_etag')
        ret = await this.loadNewData(eTagInfo.data)
      } catch (e) {
        ret = await this.loadNewData()
      }
    }

    return ret
  }

  self.saveData = async (data, eTag) => {
    if (data == null) {
      return null
    }

    if (isGlobal() === false) {
      const { departments, jobpositions, jobtitles, managers, users = [] } = data

      const entries = [
        { key: 'info_departments', data: departments },
        { key: 'info_jobpositions', data: jobpositions },
        { key: 'info_jobtitles', data: jobtitles },
        { key: 'info_managers', data: managers },
        ...users.map((user) => ({ key: user.id, data: user })),
      ]

      // etag 는 반드시 "마지막"에 넣는다. 위 메타·users 가 같은 트랜잭션에서 전부 커밋될 때만
      // etag 도 함께 커밋되므로(원자적), 저장이 부분 실패하면 트랜잭션이 롤백돼 etag 가 남지
      // 않는다 → 다음 세션이 If-None-Match 없이 200 으로 전체를 다시 받아 자가 복구된다.
      // (과거: etag 를 users 저장 전에 먼저 커밋 + users.forEach(async) 미대기 → 부분 저장이
      //  유효 etag 와 함께 고착되어 304 로 잘린 캐시를 계속 재사용하는 버그)
      if (eTag != null) {
        entries.push({ key: 'info_etag', data: eTag })
      }

      await orgChartDB.bulkReplace(entries)

      const ret = await self.loadData()

      return ret
    }

    const entries = [{ key: 'info_users', data }]
    if (eTag != null) {
      entries.push({ key: 'info_etag', data: eTag })
    }
    await orgChartDB.bulkReplace(entries)

    return data
  }

  self.loadData = async () => {
    if (isGlobal() === false) {
      // const eTag = await orgChartDB.getData('info_etag');
      const departmentsInfo = await orgChartDB.getData('info_departments')
      const jobpositionsInfo = await orgChartDB.getData('info_jobpositions')
      const jobtitlesInfo = await orgChartDB.getData('info_jobtitles')
      const managersInfo = await orgChartDB.getData('info_managers')

      const allData = await orgChartDB.getAllData()

      if (allData != null) {
        const users = allData.dataList

        const orgChartData = {
          departments: departmentsInfo.data,
          jobpositions: jobpositionsInfo.data,
          jobtitles: jobtitlesInfo.data,
          managers: managersInfo.data,
          users,
        }

        self.changeListener.notify(orgChartData)

        return orgChartData
      }
    } else {
      const { data } = await safeboxClient.get('/v1/users')
      return data?.data
    }

    return null
  }

  self.loadNewData = async (eTag) => {
    const headers = {}
    if (eTag != null) {
      headers['If-None-Match'] = eTag
    }

    let ret = null

    if (isGlobal() && store.get('app.user.token') != null) {
      // 1. safeboxClient에서 데이터 받아오기
      const res = await safeboxClient.get('/v1/users', {}, { headers })
      const { data } = res || {}

      // 2. 응답 구조가 다를 수 있으니 안전하게 data?.data 접근
      const orgData = data?.data
      const eTagFromHeader = res?.headers?.etag ?? null

      // 3. orgChartDB 저장
      if (orgData != null) {
        ret = await self.saveData(orgData, eTagFromHeader)

        if (ret == null) {
          return null
        }
      }
    } else {
      // 기존 restClient 처리
      const res = await orgChartClientRequiredToken.get('/org_chart/get_org_chart', {}, { headers })
      const { origin, data: resData } = res

      if (origin != null) {
        const { data } = resData
        if (origin.status === 200) {
          const { headers: resHeader } = origin
          const resETag = resHeader.get('Etag')
          ret = await self.saveData(data, resETag)
        } else if (origin.status === 304) {
          ret = await self.loadData()
        }
      }
    }

    return ret
  }
}

const helper = new OrgChartHelper()

const token = store.get('app.user.token')
if (token != null) {
  // 로드 시 선적재. 열기 차단·실패는 await 하는 호출처(currentAccount 등)가 각자 처리하므로
  // 여기선 "Uncaught (in promise)" 로 새지 않게만 막는다.
  helper.startLoading().catch((e) => console.warn('orgChart preload failed:', e))
}

export default helper
